import { render, staticRenderFns } from "./entrustChildList.vue?vue&type=template&id=85ab925c&scoped=true"
import script from "./entrustChildList.vue?vue&type=script&lang=js"
export * from "./entrustChildList.vue?vue&type=script&lang=js"
import style0 from "./entrustChildList.vue?vue&type=style&index=0&id=85ab925c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ab925c",
  null
  
)

export default component.exports